import { render } from "./MonthlyClosureConfiguration.vue?vue&type=template&id=255de910&scoped=true"
import script from "./MonthlyClosureConfiguration.vue?vue&type=script&lang=js"
export * from "./MonthlyClosureConfiguration.vue?vue&type=script&lang=js"

import "./MonthlyClosureConfiguration.vue?vue&type=style&index=0&id=255de910&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-255de910"

export default script